import React, { memo, forwardRef } from "react";
const SvgBinomialCoefficient = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        d="M28.535 10.04c.648 2.017.972 4.078.972 6.184s-.324 4.176-.972 6.21c-.648 2.016-1.503 3.78-2.565 5.292-.216.306-.468.459-.756.459a.808.808 0 01-.594-.243.722.722 0 01-.243-.567c0-.18.072-.387.216-.621.954-1.476 1.71-3.132 2.268-4.968.576-1.836.864-3.69.864-5.562 0-1.872-.288-3.726-.864-5.562-.558-1.836-1.314-3.492-2.268-4.968-.144-.234-.216-.441-.216-.621 0-.234.081-.423.243-.567a.808.808 0 01.594-.243c.288 0 .54.153.756.459 1.062 1.512 1.917 3.285 2.565 5.319zM4.108 22.434a20.341 20.341 0 01-.972-6.21c0-2.106.324-4.167.972-6.183.648-2.034 1.503-3.807 2.565-5.32.216-.305.468-.458.756-.458.234 0 .432.08.594.243a.722.722 0 01.243.567c0 .18-.072.387-.216.62-.954 1.477-1.72 3.133-2.295 4.969a19.031 19.031 0 00-.837 5.562c0 1.872.279 3.726.837 5.562.576 1.836 1.34 3.492 2.295 4.968.144.234.216.44.216.62a.722.722 0 01-.243.568.808.808 0 01-.594.243c-.288 0-.54-.153-.756-.46-1.062-1.511-1.917-3.275-2.565-5.291z"
      />
      <rect width={8} height={10} x={12} y={5} fill="#DBDBDB" rx={1} />
      <rect width={8} height={10} x={12} y={17} fill="#DBDBDB" rx={1} />
    </svg>
  );
});
SvgBinomialCoefficient.displayName = "SvgBinomialCoefficient";
const MemoForwardRef = memo(SvgBinomialCoefficient);
export default MemoForwardRef;
